import { Enrollment } from '@shared/common';
import { useContext, useMemo } from 'react';
import SyncLmsEnrollmentsButton from '../../../SyncLmsEnrollmentsButton';
import { MentorDetailsPageContext } from '../../MentorDetailsPage';
import EnrolledInTable from './enrolledIn/EnrolledInTable';
import TeachingEnrollmentsTable from './teaching/TeachingEnrollmentsTable';

interface EnrollmentsTabProps {
  areEnrollmentsActive?: boolean;
}

const EnrollmentsTab = (props: EnrollmentsTabProps) => {
  const { areEnrollmentsActive = false } = props;

  const { mentor } = useContext(MentorDetailsPageContext);

  const { teaching, enrolledIn } = useMemo(() => {
    const teaching: Partial<Enrollment>[] = [];
    const enrolledIn: Partial<Enrollment>[] = [];

    mentor?.enrollments?.forEach((enrollment) => {
      if (enrollment.user?._id === mentor._id) {
        enrolledIn.push(enrollment);
      } else if (enrollment.mentor?._id === mentor._id) {
        teaching.push(enrollment);
      }
    });

    return { teaching, enrolledIn };
  }, [mentor?.enrollments]);

  return (
    <>
      {areEnrollmentsActive && (
        <div className="flex justify-end">
          <SyncLmsEnrollmentsButton className="h-6 min-h-6" userId={mentor?._id} />
        </div>
      )}
      <TeachingEnrollmentsTable
        areEnrollmentsActive={areEnrollmentsActive}
        enrollments={teaching}
      />
      <EnrolledInTable areEnrollmentsActive={areEnrollmentsActive} enrollments={enrolledIn} />
    </>
  );
};

export default EnrollmentsTab;
